<div class="check_phone_number_wrapper">
  <div class="check_phone_number_body" v-click-outside="close">
    <div class="check_phone_number_title">
      {{$t('check_phone_number.title')}}
    </div>
    <div class="check_phone_number_row">
      <v-input
        ref="newPhoneInput"
        class="edit_client_elment"
        v-model="newPhone"
        placeholder="+7 (000) 000-00-00"
        v-maska:[phoneMaskOptions]
        :label="$t('check_phone_number.new_phone_title')"
        height="22"
        :errorText="phoneErrorText"
        @focus="phoneErrorText = ''"
        clearable
      ></v-input>
    </div>

    <div class="check_phone_number_row" v-if="showCodeInput">
      <v-input
        ref="codeInput"
        class="edit_client_elment"
        v-model="code"
        placeholder=""
        :label="$t('check_phone_number.code_title')"
        height="22"
        clearable
      ></v-input>
    </div>
    <div class="check_phone_number_row" v-if="codeErrorText?.length > 0">
        <p class="error_text">{{codeErrorText}}</p>
    </div>
    <div class="check_phone_number_buttons_wrapper">
      <button class="primary_button" @click="sendCode" :disabled="(!phoneMaskValidated || isSendCodeButtonDisabled)" v-show="showSendButton">{{$t('check_phone_number.btn_send_code') }}</button>
      <button class="primary_button" @click="checkCode" :disabled="isCheckCodeButtonDisabled" v-show="showCheckButton">{{$t('check_phone_number.btn_check_code') }}</button>
      <button class="secondary_button button_space" @click="$emit('close')">{{$t('check_phone_number.btn_cancel')}}</button>
    </div>
  </div>
</div>
